<template>
  <div class="calendar-year">
    <month-box
      v-for="(month, index) in monthList"
      :key="index"
      :month="index"
      :year="selectedYear"
      :taskCount="taskCount"
    ></month-box>
  </div>
</template>
<script>
import MonthBox from './monthBox'
import moment from 'moment'
/* eslint-disable-next-line */
import Worker from 'workerize-loader!@/plugin/worker/calendar'
export default {
  name: 'CalendarYearView',
  components: {
    MonthBox
  },
  props: {
    curDate: {
      type: String,
      default: moment().format('YYYY年MM月DD日')
    }
  },
  data () {
    return {
      monthList: new Array(12),
      tasks: [],
      taskCount: {}
    }
  },
  computed: {
    selectedYear () {
      return moment([this.curDate]).get('year')
    }
  },
  watch: {
    curDate () {
      this.setParams()
    },
    '$store.state.calendar.tasks': {
      handler: function (newer, older) {
        // this.taskCount = this.setTaskCountByDay(newer)
        this.setTaskCountByDay(newer)
      },
      deep: true
    }
  },
  created () {
    this.setParams()
  },
  methods: {
    setParams () {
      let yearStart = moment(this.curDate, 'YYYY-MM-DD').startOf('year')
      let yearEnd = moment(this.curDate, 'YYYY-MM-DD').endOf('year')
      let rangeFrom = yearStart.startOf('week').format('YYYY-MM-DD')
      let rangeTo = yearEnd.endOf('week').format('YYYY-MM-DD')
      this.$store.commit('updateCalendarParams', { rangeFrom, rangeTo })
    },
    /**
     * 计算每天任务
     */
    setTaskCountByDay (tasks) {
      if (this.calendarWorker) {
        this.calendarWorker = Worker()
      }
      this.calendarWorker.setTaskCountByDay(tasks).then(res => {
        if (res.type === 'calendarYearTasks') {
          this.taskCount = res.array || []
        }
      })

      // let result = {}
      // tasks.map(item => {
      //   let startTime = moment(item.startTime || item.dueTime)
      //   const days = moment(item.endTime || item.dueTime).diff(moment(startTime).startOf('day'), 'days') + 1
      //   for (let index = 0; index < days; index++) {
      //     const key = moment(item.startTime || item.dueTime).add(index, 'day').format('YYYY-MM-DD')
      //     result[key] = result[key] || []
      //     result[key].push(item)
      //   }
      // })
      // return result
    }
  }
}
</script>
<style lang="stylus">
.calendar-year
  display flex
  flex-wrap wrap
  .calendar-year-month
    flex 0 0 25%
</style>
